enum Mutation {
  SET_ABSENCE_REASONS_IDS = 'setAbsenceReasonsIds',
  SET_LOCATIONS_POSITION_IDS = 'setLocationsPositionIds',
  SET_FILTERS = 'setFilters',
}

export default Mutation;
